import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthModalVariant} from "../components/auth_modal/AuthModalHeaderVariants";
import {AuthActionType} from "../types/AuthActionType";

export type IAuthModalVariant = "default" | "extended" | "download_report" | "hidden_prices_variant_b";

export interface IAuthModalState {
    isOpen: boolean;
    userSource: UserSource | null;
    gtmSourceSection?: string;
    headerVariant: AuthModalVariant;
    modalVariant: IAuthModalVariant;
    lastAuthAction: AuthActionType | null;
}

const initialState: IAuthModalState = {
    isOpen: false,
    userSource: null,
    gtmSourceSection: undefined,
    headerVariant: AuthModalVariant.DEFAULT,
    modalVariant: "extended",
    lastAuthAction: null
};

export interface IOpenAuthModalPayload {
    userSource: UserSource;
    gtmSourceSection?: string;
    headerVariant?: AuthModalVariant;
    modalVariant?: IAuthModalVariant;
}

export const authModalSlice = createSlice({
    name: "authModal",
    initialState,
    reducers: {
        openAuthModal: (state, action: PayloadAction<IOpenAuthModalPayload>) => {
            const {userSource, gtmSourceSection, headerVariant = AuthModalVariant.DEFAULT, modalVariant = "extended"} = action.payload;

            state.isOpen = true;
            state.userSource = userSource;
            state.gtmSourceSection = gtmSourceSection;
            state.headerVariant = headerVariant;
            state.modalVariant = modalVariant;
            state.lastAuthAction = null; // Reset when opening modal
        },
        closeAuthModal: (state) => {
            state.isOpen = false;
            state.userSource = null;
            state.gtmSourceSection = undefined;
            state.headerVariant = AuthModalVariant.DEFAULT;
            state.modalVariant = "extended";
        },
        setAuthModalHeaderVariant: (state, action: PayloadAction<{headerVariant: AuthModalVariant}>) => {
            const {headerVariant} = action.payload;
            state.headerVariant = headerVariant;
        },
        setLastAuthAction: (state, action: PayloadAction<{authAction: AuthActionType}>) => {
            const {authAction} = action.payload;
            state.lastAuthAction = authAction;
        }
    }
});

export const {openAuthModal, closeAuthModal, setAuthModalHeaderVariant, setLastAuthAction} = authModalSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthModalVariant} from "../components/auth_modal/AuthModalHeaderVariants";
import {AuthActionType} from "../types/AuthActionType";

export type IAuthModalVariant = "default" | "extended" | "download_report" | "hidden_prices_variant_b";

export interface IAuthModalState {
    isOpen: boolean;
    userSource: UserSource | null;
    gtmSourceSection?: string;
    headerVariant: AuthModalVariant;
    modalVariant: IAuthModalVariant;
    lastAuthAction: AuthActionType | null;
}

const initialState: IAuthModalState = {
    isOpen: false,
    userSource: null,
    gtmSourceSection: undefined,
    headerVariant: AuthModalVariant.DEFAULT,
    modalVariant: "extended",
    lastAuthAction: null
};

export interface IOpenAuthModalPayload {
    userSource: UserSource;
    gtmSourceSection?: string;
    headerVariant?: AuthModalVariant;
    modalVariant?: IAuthModalVariant;
}

export const authModalSlice = createSlice({
    name: "authModal",
    initialState,
    reducers: {
        openAuthModal: (state, action: PayloadAction<IOpenAuthModalPayload>) => {
            const {userSource, gtmSourceSection, headerVariant = AuthModalVariant.DEFAULT, modalVariant = "extended"} = action.payload;

            state.isOpen = true;
            state.userSource = userSource;
            state.gtmSourceSection = gtmSourceSection;
            state.headerVariant = headerVariant;
            state.modalVariant = modalVariant;
            state.lastAuthAction = null; // Reset when opening modal
        },
        closeAuthModal: (state) => {
            state.isOpen = false;
            state.userSource = null;
            state.gtmSourceSection = undefined;
            state.headerVariant = AuthModalVariant.DEFAULT;
            state.modalVariant = "extended";
        },
        setAuthModalHeaderVariant: (state, action: PayloadAction<{headerVariant: AuthModalVariant}>) => {
            const {headerVariant} = action.payload;
            state.headerVariant = headerVariant;
        },
        setLastAuthAction: (state, action: PayloadAction<{authAction: AuthActionType}>) => {
            const {authAction} = action.payload;
            state.lastAuthAction = authAction;
        }
    }
});

export const {openAuthModal, closeAuthModal, setAuthModalHeaderVariant, setLastAuthAction} = authModalSlice.actions;
